import { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { AuthData } from '../../auth/AuthWrapper';
import userService from '../../services/userService';
import { IconUser, IconBuildingSkyscraper, IconPhone, IconMail, IconLock, IconBriefcase, IconWorld, IconShieldCheck, IconShieldLock, IconCookie } from '@tabler/icons-react';
import { KamaModal } from '../structure/KamaModal';

export const MyAccount = () => {
    const { t, i18n } = useTranslation();
    const { user, setUser } = AuthData();
    const location = useLocation();
    const forceRiza = location.state?.forceRiza;
    
    const handleSubmit = async (e) => {

        e.preventDefault();
        // Backend'e gönderilecek dil bilgisi olarak o anki aktif dili kullanıyoruz
        let currentLang = i18n.language; 
        let regobj = { 
            UserId, FirmaAdi, Bolum, AdiSoyadi, Eposta, Sifre, Telefon, WebSitesi, 
            MailDogrulama, ActivationKey, Rol, Language: currentLang,
            RizaOnay: RizaOnay ? 1 : 0,
            RizaOnayDate: RizaOnayDate || new Date().toISOString()
        }
        
        if (IsValidate()) {
            try {
                const res = await userService.updateUser(regobj);
                if (res == "OK") {
                    // Güncelleme başarılıysa localStorage'ı da garantiye alalım
                    localStorage.setItem('siteLang', currentLang);
                    
                    if (editMode) {
                        // Riza onay bilgisini güncelle
                        if (RizaOnay) {
                            sessionStorage.setItem("rizaOnay", "1");
                            
                            // Cookie'yi de güncelle (Beni Hatırla seçiliyse)
                            const match = document.cookie.match(new RegExp('(^| )kama3d_session=([^;]+)'));
                            if (match) {
                                try {
                                    const cookieData = JSON.parse(decodeURIComponent(match[2]));
                                    cookieData.rizaOnay = true;
                                    const expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toUTCString();
                                    document.cookie = `kama3d_session=${encodeURIComponent(JSON.stringify(cookieData))};expires=${expires};path=/;SameSite=Strict`;
                                } catch (e) { console.error("Cookie update error", e); }
                            }

                            // Global state'i güncelle
                            setUser({ ...user, rizaOnay: true });
                        }

                        toast(t('mesajBilgilerinizGuncellendi'))
                        navigate('/')
                    }
                    else {
                        toast(t('mesajUyelikBasarili'))
                        navigate('/login')
                    }
                } else {
                    toast(res)
                }
            } catch (err) {
                toast.error(t('mesajKayitYapilamiyor') + (err.message || ""))
            }
        }
    }


    const [UserId, idChange] = useState(0);
    const [Eposta, EpostaChange] = useState("");
    const [Sifre, sifreChange] = useState("");
    const [AdiSoyadi, adSoyadChange] = useState("");
    const [FirmaAdi, FirmaAdiChange] = useState("");
    const [Bolum, bolumChange] = useState("");
    const [WebSitesi, webSitesiChange] = useState("");
    const [Telefon, telefonChange] = useState("");
    const [MailDogrulama, mailDogrulamaChange] = useState(0)
    const [ActivationKey, setaKey] = useState("")
    const [Rol, rolChange] = useState(2);
    const [Language, setLanguage] = useState(i18n.language)
    const [RizaOnay, setRizaOnay] = useState(false);
    const [RizaOnayDate, setRizaOnayDate] = useState(null);
    const [showModal, setShowModal] = useState(null);

    const openModal = (type) => setShowModal(type);
    const closeModal = () => setShowModal(null);

    // E-posta kontrolü için state'ler
    const [initialEmail, setInitialEmail] = useState("");
    const [emailError, setEmailError] = useState("");

    const formatPhoneNumber = (value) => {
        if (!value) return value;
        const phoneNumber = value.replace(/[^\d]/g, "");
        const phoneNumberLength = phoneNumber.length;
        if (phoneNumberLength < 4) return phoneNumber;
        if (phoneNumberLength < 7) {
            return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
        }
        if (phoneNumberLength < 9) {
            return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)} ${phoneNumber.slice(6)}`;
        }
        return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)} ${phoneNumber.slice(6, 8)} ${phoneNumber.slice(8, 10)}`;
    };

    const handlePhoneChange = (e) => {
        const formattedValue = formatPhoneNumber(e.target.value);
        if (formattedValue.length <= 15) {
            telefonChange(formattedValue);
        }
    };

    const handleEmailBlur = async () => {
        if (!Eposta) {
            setEmailError("");
            return;
        }

        // Kendi e-postasıysa kontrol etme
        if (Eposta === initialEmail) {
            setEmailError("");
            return;
        }

        // Regex kontrolü
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegex.test(Eposta)) {
            setEmailError(t('mesajEPostaUyari'));
            return;
        }

        try {
            const response = await userService.checkEmail(Eposta);
            // API { exists: true, message: "..." } dönüyor
            if (response && response.exists === true) {
                setEmailError(t('mesajEpostaKullanimda'));
            } else {
                setEmailError("");
            }
        } catch (error) {
            console.error("Email check error:", error);
        }
    };

    const editMode = sessionStorage.getItem("activationKey") ? true : false;

    useEffect(() => {
        if (editMode) { fillForm() }
    }, []);

    const fillForm = async () => {
        try {
            const data = await userService.getUserFromKey(sessionStorage.getItem("activationKey"));
            if (data && data[0]) {
                idChange(data[0].UserId);
                EpostaChange(data[0].Eposta);
                setInitialEmail(data[0].Eposta); // Orijinal e-postayı sakla
                sifreChange(data[0].Sifre);
                adSoyadChange(data[0].AdiSoyadi);
                FirmaAdiChange(data[0].FirmaAdi);
                bolumChange(data[0].Bolum);
                webSitesiChange(data[0].WebSitesi);
                // Gelen veriyi maskele
                telefonChange(formatPhoneNumber(data[0].Telefon));
                setaKey(sessionStorage.getItem("activationKey"));
                setRizaOnay(data[0].RizaOnay === true || data[0].RizaOnay === 1);
                setRizaOnayDate(data[0].RizaOnayDate);
            }
        } catch (error) {
            toast.warning(t('mesajOturumZamanAsimi'))
            const link = document.createElement('a');
            link.href = "/login";
            document.body.appendChild(link);
            link.click();
        }
    }

    const navigate = useNavigate();
    const IsValidate = () => {
        let isProceed = true;
        let errorMessage = t('mesajUyelikBosAlanlar');

        if (emailError) {
            isProceed = false;
            errorMessage = emailError;
        }

        if (Eposta === null || Eposta === '') {
            isProceed = false;
            errorMessage += t('formUyelikEposta') + ' ';
        }

        if (Sifre === null || Sifre === '') {
            isProceed = false;
            errorMessage += t('formUyelikSifre') + ' ';
        }

        if (AdiSoyadi === null || AdiSoyadi === '') {
            isProceed = false;
            errorMessage += t('formUyelikAdSoyad') + ' ';
        }

        if (Sifre.length > 12) {
            isProceed = false;
            errorMessage += t('mesajSifreUzunluguUyari') + ' ';
        }

        if (Sifre.length < 6) {
            isProceed = false;
            errorMessage += t('mesajSifreUzunluguUyari') + ' ';
        }
        if (FirmaAdi.length < 3) {
            isProceed = false;
            errorMessage += t('mesajFirmaAdiUyari') + ' ';
        }

        if (Telefon.length < 15) {
            isProceed = false;
            errorMessage += t('mesajTelefonUyari') + ' ';
        }

        if (!RizaOnay) {
            isProceed = false;
            errorMessage = t('kvkkHata');
        }

        if (!isProceed) {
            toast.warning(errorMessage)
        } else {
            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (!emailRegex.test(Eposta)) {
                isProceed = false;
                toast.warning(t('mesajEPostaUyari'))
            }
        }
        return isProceed;
    }


    const sectionLabel = {
        fontSize: '11px',
        fontWeight: 700,
        textTransform: 'uppercase',
        letterSpacing: '1px',
        color: '#94a3b8',
        marginBottom: '16px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    };

    const fieldLabel = {
        fontSize: '12px',
        fontWeight: 600,
        color: '#475569',
        marginBottom: '6px',
        display: 'block',
    };

    return (
        <div style={{ maxWidth: '760px' }}>

            {/* Profil Başlığı */}
            <div className="rounded-4 mb-4 p-4 d-flex align-items-center gap-3"
                style={{ background: 'linear-gradient(135deg, #1e2a38 0%, #2563a8 100%)' }}>
                <div style={{
                    width: 60, height: 60, borderRadius: '50%',
                    background: 'rgba(255,255,255,0.15)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0
                }}>
                    <IconUser size={30} color="#fff" />
                </div>
                <div>
                    <h5 className="mb-0 fw-bold text-white">
                        {editMode ? t('formUyelikBaslikDuzenle') : t('formUyelikBaslikYeni')}
                    </h5>
                    {editMode && <small style={{ color: 'rgba(255,255,255,0.6)' }}>{Eposta}</small>}
                </div>
            </div>

            <form onSubmit={handleSubmit}>

                {/* Hesap Bilgileri */}
                <div className="card border-0 shadow-sm rounded-4 mb-3">
                    <div className="card-body p-4">
                        <div style={sectionLabel}>
                            <IconLock size={14} />
                            {t('formUyelikEposta')} & {t('formUyelikSifre')}
                        </div>
                        <div className="row g-3">
                            <div className="col-md-6">
                                <label style={fieldLabel}>{t('formUyelikEposta')} *</label>
                                <div className="input-group">
                                    <span className="input-group-text bg-light border-end-0">
                                        <IconMail size={16} color="#94a3b8" />
                                    </span>
                                    <input
                                        type="text"
                                        className={`form-control border-start-0 ps-1 ${emailError ? 'is-invalid' : ''}`}
                                        value={Eposta}
                                        onChange={(e) => { EpostaChange(e.target.value); setEmailError(""); }}
                                        onBlur={handleEmailBlur}
                                        placeholder="ornek@kama.com.tr"
                                    />
                                    {emailError && <div className="invalid-feedback">{emailError}</div>}
                                </div>
                            </div>
                            <div className="col-md-6">
                                <label style={fieldLabel}>{t('formUyelikSifre')} *</label>
                                <div className="input-group">
                                    <span className="input-group-text bg-light border-end-0">
                                        <IconLock size={16} color="#94a3b8" />
                                    </span>
                                    <input
                                        type="password"
                                        className="form-control border-start-0 ps-1"
                                        value={Sifre}
                                        onChange={(e) => sifreChange(e.target.value)}
                                        placeholder="••••••"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Kişisel Bilgiler */}
                <div className="card border-0 shadow-sm rounded-4 mb-3">
                    <div className="card-body p-4">
                        <div style={sectionLabel}>
                            <IconUser size={14} />
                            {t('formUyelikAdSoyad')} & {t('formUyelikFirmaAdi')}
                        </div>
                        <div className="row g-3">
                            <div className="col-md-6">
                                <label style={fieldLabel}>{t('formUyelikAdSoyad')} *</label>
                                <div className="input-group">
                                    <span className="input-group-text bg-light border-end-0">
                                        <IconUser size={16} color="#94a3b8" />
                                    </span>
                                    <input
                                        type="text"
                                        className="form-control border-start-0 ps-1"
                                        value={AdiSoyadi}
                                        onChange={(e) => adSoyadChange(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <label style={fieldLabel}>{t('formUyelikFirmaAdi')} *</label>
                                <div className="input-group">
                                    <span className="input-group-text bg-light border-end-0">
                                        <IconBuildingSkyscraper size={16} color="#94a3b8" />
                                    </span>
                                    <input
                                        type="text"
                                        className="form-control border-start-0 ps-1"
                                        value={FirmaAdi}
                                        onChange={(e) => FirmaAdiChange(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="col-12">
                                <label style={fieldLabel}>{t('formUyelikBolum')}</label>
                                <div className="input-group">
                                    <span className="input-group-text bg-light border-end-0">
                                        <IconBriefcase size={16} color="#94a3b8" />
                                    </span>
                                    <input
                                        type="text"
                                        className="form-control border-start-0 ps-1"
                                        value={Bolum}
                                        onChange={(e) => bolumChange(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* İletişim */}
                <div className="card border-0 shadow-sm rounded-4 mb-4">
                    <div className="card-body p-4">
                        <div style={sectionLabel}>
                            <IconPhone size={14} />
                            {t('formUyelikTelefon')} & {t('formUyelikWebSitesi')}
                        </div>
                        <div className="row g-3">
                            <div className="col-md-6">
                                <label style={fieldLabel}>{t('formUyelikTelefon')} *</label>
                                <div className="input-group">
                                    <span className="input-group-text bg-light border-end-0">
                                        <IconPhone size={16} color="#94a3b8" />
                                    </span>
                                    <input
                                        type="text"
                                        className="form-control border-start-0 ps-1"
                                        value={Telefon}
                                        onChange={handlePhoneChange}
                                        placeholder="(5XX) XXX XX XX"
                                        maxLength="15"
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <label style={fieldLabel}>{t('formUyelikWebSitesi')}</label>
                                <div className="input-group">
                                    <span className="input-group-text bg-light border-end-0">
                                        <IconWorld size={16} color="#94a3b8" />
                                    </span>
                                    <input
                                        type="text"
                                        className="form-control border-start-0 ps-1"
                                        value={WebSitesi}
                                        onChange={(e) => webSitesiChange(e.target.value)}
                                        placeholder="www.firma.com.tr"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* KVKK Onay */}
                <div className="card border-0 shadow-sm rounded-4 mb-4" style={forceRiza ? { border: '1px solid #dc3545' } : {}}>
                    <div className="card-body p-4">
                        {forceRiza && (
                            <div className="alert alert-danger mb-3">
                                <div className="d-flex align-items-center gap-2 mb-2">
                                    <IconShieldCheck size={20} />
                                    {t('kvkkZorunluMesaj')}
                                </div>
                                <div style={{ marginLeft: '28px' }}>
                                    <span 
                                        onClick={() => openModal('kvkk')}
                                        style={{ 
                                            fontSize: '12px', 
                                            color: '#b91c1c', 
                                            textDecoration: 'underline', 
                                            cursor: 'pointer',
                                            fontWeight: 600
                                        }}
                                    >
                                        {i18n.language.startsWith('tr') ? 'Kişisel Verilerin Korunması Metni' : 'Personal Data Protection Text'}
                                    </span>
                                </div>
                            </div>
                        )}
                        <div className="form-check">
                            <input 
                                className="form-check-input" 
                                type="checkbox" 
                                id="rizaOnay" 
                                checked={RizaOnay}
                                onChange={(e) => {
                                    setRizaOnay(e.target.checked);
                                    if (e.target.checked) setRizaOnayDate(new Date().toISOString());
                                }}
                            />
                            <label className="form-check-label fw-600" htmlFor="rizaOnay" style={{ fontSize: '13px', color: '#475569' }}>
                                {t('kvkkOnayMetni')}
                            </label>
                        </div>
                    </div>
                </div>

                {/* Butonlar */}
                <div className="d-flex justify-content-end gap-2">
                    {!forceRiza && (
                        <Link to={editMode ? '/' : '/login'} className="btn btn-outline-secondary px-4">
                            {t('butonVazgec')}
                        </Link>
                    )}
                    <button type="submit" className="btn btn-primary px-4 fw-bold">
                        {editMode ? t('butonGuncelle') : t('butonKayitOl')}
                    </button>
                </div>

            </form>

            <KamaModal
                show={showModal !== null}
                onHide={closeModal}
                title={showModal === 'kvkk' ? (i18n.language.startsWith('tr') ? 'Kişisel Verilerin Korunması' : 'Personal Data Protection') : (i18n.language.startsWith('tr') ? 'Çerez Politikası' : 'Cookie Policy')}
                icon={showModal === 'kvkk' ? <IconShieldLock size={20} /> : <IconCookie size={20} />}
                size="lg"
                footer={
                    <button className="btn btn-primary fw-bold px-5" onClick={closeModal}>
                        {t('butonKapat')}
                    </button>
                }
            >
                <iframe
                    src={showModal === 'kvkk' ? '/kvkk.html' : '/cerez-politikasi.html'}
                    title={showModal === 'kvkk' ? 'Kişisel Verilerin Korunması' : 'Çerez Politikası'}
                    style={{ width: '100%', height: '65vh', border: 'none', display: 'block' }}
                />
            </KamaModal>
        </div>
    );
}


